import * as React from 'react';
import { useCallback } from 'react';
import { Collapse } from '@mui/material';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { ThemeProvider } from '../../../../../theme';
import { IconButton } from '../../../../../BaseComponents';
import { TaxesDetails } from '../TaxesDetails';
import { CdnIcon } from '@shared/ui';
const TaxesCollapse = ({ className, classNames, defaultOpen = false, taxesDetails, children }) => {
    var _a;
    const { TaxesCollapse: theme } = useTheme('Entities').Fare;
    const [open, setOpen] = React.useState(defaultOpen);
    const content = taxesDetails.totalPrice && ((_a = taxesDetails.passengerFares) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(ThemeProvider, { value: {
            Entities: {
                Fare: {
                    TaxesDetails: {
                        price__label: theme.price__label,
                        price__item: theme.price__item,
                        price__item_highlighted: theme.price__item_highlighted
                    }
                }
            }
        } },
        React.createElement(TaxesDetails, Object.assign({}, taxesDetails))));
    const isEnabled = !!content;
    const handleToggle = useCallback(() => {
        if (!isEnabled) {
            return;
        }
        setOpen(open => !open);
    }, [isEnabled, setOpen]);
    const handleKeyDown = useCallback(e => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle();
        }
    }, [handleToggle]);
    return (React.createElement("div", { className: cn(theme.root, className, classNames === null || classNames === void 0 ? void 0 : classNames.root, {
            [theme.enabled]: isEnabled,
            [theme.rootOpened]: open
        }) },
        React.createElement("div", { className: cn(theme.trigger, classNames === null || classNames === void 0 ? void 0 : classNames.trigger), role: "button", tabIndex: 0, "aria-expanded": open, onClick: handleToggle, onKeyDown: handleKeyDown },
            React.createElement("div", { className: theme.triggerContent }, children),
            isEnabled && (React.createElement(IconButton, { className: theme.triggerButton },
                React.createElement(CdnIcon, { icon: "Arrow/Expand_more" })))),
        isEnabled && (React.createElement(Collapse, { in: open, timeout: "auto", unmountOnExit: true }, content))));
};
export default TaxesCollapse;
